import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import Category from './category';
import SubscriptionLine from './subscriptionLine';

import { Table, Td, Th, Thead, Tr } from '../managedITServices/components/css';
import request from '../../../utils/request';
import {
  saveOption,
  saveOptionPricing,
  saveQuestion,
  saveService,
  saveServiceInOffering
} from '../managedITServices/components/saveSchemaToDB';

import ValidateLoader from '../../../UI/validateLoader';

const MicrosoftLicensing = () => {
  //   const [
  //     microsoftLicensingAdminData,
  //     setMicrosoftLicensingAdminData
  //   ] = useState(() => {
  //     // Retrieve the array from localStorage if it exists
  //     const savedItems = localStorage.getItem('microsoftLicensingData2');
  //     return savedItems ? JSON.parse(savedItems) : microsoftLicensingData2;
  //   });
  const [
    microsoftLicensingAdminData,
    setMicrosoftLicensingAdminData
  ] = useState([]);
  const [microsoftLicensingDbData, setMicrosoftLicensingDbData] = useState([]);
  
  const [categorySelected, setCategorySelected] = useState('');
  const [categoryEditMode, setCategoryEditMode] = useState(false);
  const [subscriptionLineEditMode, setSubscriptionLineEditMode] = useState(
    false
  );
  const [isLoading,setIsLoading] = useState(true)
  const [isOptionSelected,setIsOptionSelected] = useState(false);
  const [offeringId, setOfferingId] = useState(null);
  const [serviceId, setServiceId] = useState(null);

  useEffect(() => {
    setSubscriptionLineEditMode(false);
  }, [categorySelected]);

  const sortByIdxRecursively = (data) => {
    if (Array.isArray(data)) {
      // Sort the array by the 'ord' key if present
      data.sort((a, b) => (a.ord !== undefined ? a.ord : Infinity) - (b.ord !== undefined ? b.ord : Infinity));
      // Recursively process each element of the array
      data.forEach(sortByIdxRecursively);
    } else if (data && typeof data === 'object') {
      // If it's an object, process each key
      Object.values(data).forEach(sortByIdxRecursively);
    }
  };

  const saveLicensingData = data => {
    const licensingData = data.find(
      item => item.id === 5 && item.name === 'Microsoft Licensing'
    );
    setOfferingId(licensingData.id);
    setServiceId(licensingData.ServicesInOffering[0].id);
    const myData = data[1].ServicesInOffering[0].productCatalogQuestions;
    sortByIdxRecursively(myData);
    setMicrosoftLicensingAdminData(
      myData
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get('/productCatalog');
        saveLicensingData(response.data[0].productCatalogOfferings);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      finally{
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (categoryEditMode) setSubscriptionLineEditMode(false);
  }, [categoryEditMode]);

  //   useEffect(() => {
  //     localStorage.setItem(
  //       'microsoftLicensingData2',
  //       JSON.stringify(microsoftLicensingAdminData)
  //     );
  //   }, [microsoftLicensingAdminData]);

  return (
    isLoading ? (<ValidateLoader
        message="Please wait request is In progress...."
        isFormStep={isLoading}
      />) : (
    <Table>
      <Thead>
        <Tr>
          <Th width="30%">Add Subscription</Th>
          <Th width="30%"></Th>
          <Th width="30%">{isOptionSelected ? 'Cost' : ''}</Th>
          <Th width="10%">{isOptionSelected ? 'Price' : ''}</Th>
          {/* <Th width="10%">Price</Th> */}
        </Tr>
      </Thead>
      <tbody>
        <Category
          microsoftLicensingAdminData={microsoftLicensingAdminData}
          offeringId={offeringId}
          serviceId={serviceId}
          setMicrosoftLicensingAdminData={setMicrosoftLicensingAdminData}
          setCategorySelected={setCategorySelected}
          editMode={categoryEditMode}
          setEditMode={setCategoryEditMode}
        />
        <SubscriptionLine
          microsoftLicensingAdminData={microsoftLicensingAdminData}
          setMicrosoftLicensingAdminData={setMicrosoftLicensingAdminData}
          categorySelected={categorySelected}
          editMode={subscriptionLineEditMode}
          setEditMode={setSubscriptionLineEditMode}
          categoryEditMode={categoryEditMode}
          setIsOptionSelected={setIsOptionSelected}
        />
      </tbody>
      
    </Table>
)
  );
};

export default MicrosoftLicensing;
